export default __webpack_public_path__ + "static/media/Oportunidades-de-Emprego-PT.4757aebc.jpg";